import '../node_modules/normalize.css/normalize.css'
import 'antd/dist/antd.css'
import './../src/styles/common.scss'
import './assets/css/common.scss'
import './assets/css/sub.scss'

import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {Provider} from 'mobx-react'
import {useStrict} from 'mobx'

import App from './router'
import store from './store'
import {ReactComponentConstructor} from "../src/types/react";

useStrict(true)

const render = (Component: ReactComponentConstructor) => {
  ReactDOM.render(
    <Provider {...store}>
      <Component />
    </Provider>,
    document.getElementById('app') as HTMLElement
  )
}

// CSRFトークンを取得してからアプリを起動
fetch('/api/csrf-cookie', {
  credentials: 'include'
}).then(() => {
  console.log('[CSRF] Token initialized');
  render(App);
}).catch((error) => {
  console.error('[CSRF] Failed to initialize token:', error);
  // エラーが発生してもアプリを起動
  render(App);
});

// Hot Module Replacement API
// if (module.hot) { }
